import React from "react";
import "./ImgModal.scss";

export function ImgModal({src, desc=""}) {

    return (
        <>
            <div className="modal fade" id="myModal">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header no-border">
                            <button type="button" className="close" data-dismiss="modal">
                                <span aria-hidden="true">&times;</span><span className="sr-only">Close</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="modal-img-wrapper">
                                <img src={src}/>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <h3 className="text-left no-margin">{desc}</h3>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}